export default class StringFormat {
  static kebabCase(value: string): string {
    return value
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/[\s_]+/g, '-')
      .toLowerCase()
  }

  static camelCaseToString(value: string): string {
    return value.replace(/([a-z])([A-Z])/g, '$1 $2')
  }

  static kebabToCamelCase(value: string): string {
    const [word, ...words] = value.split('-')

    return `${word}${words.map(word => `${word[0].toUpperCase()}${word.slice(1)}`).join('')}`
  }

  static isCoordinate(value: string): boolean {
    return /^([\-0-9.]+),([\-0-9.]+)$/.test(value)
  }
}
